import styled from 'styled-components';
import { Spin } from 'antd';

export const AccountPageSpin = styled(Spin)`
    top: 0 !important;
`;
